import { useEffect, useState } from "react";
import { Progress, Card } from "@pushpress/pushpress-ui";

export default function ActivatingScreen({
  enableAsyncActivation,
  totalCount,
}: {
  enableAsyncActivation: boolean;
  totalCount: number;
}) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Simulate progress with diminishing increments
    const simulateProgress = () => {
      setProgress((oldProgress) => {
        // Progress gets slower as it approaches 100%
        if (oldProgress >= totalCount) return oldProgress;

        // Calculate smaller increments as we progress
        const remaining = totalCount - oldProgress;
        const increment = Math.max(1, Math.floor(remaining * 0.001));
        // At least 1 member at a time
        return Math.min(oldProgress + increment, totalCount - 1);
      });
    };

    const timer = setInterval(simulateProgress, 1000);

    return () => clearInterval(timer);
  }, [totalCount]);

  const progressPercentage = (progress / totalCount) * 100;

  return (
    <Card className="tw-p-6 tw-mt-10">
      <div className="tw-flex tw-justify-center tw-items-center tw-h-[220px]">
        <div className="tw-w-full tw-max-w-md tw-bg-white">
          <div className="tw-flex tw-flex-col tw-items-center tw-space-y-4">
            <div className="tw-relative tw-w-16 tw-h-16">
              <div className="tw-absolute tw-top-0 tw-left-0 tw-w-16 tw-h-16 tw-border-4 tw-border-blue-200 tw-rounded-full"></div>
              <div
                className="tw-absolute tw-top-0 tw-left-0 tw-w-16 tw-h-16 tw-border-4 tw-border-blue-500 tw-rounded-full tw-animate-spin"
                style={{
                  borderTopColor: "transparent",
                  animationDuration: "1s",
                  animationTimingFunction: "linear",
                  animationIterationCount: "infinite",
                }}
              />
            </div>
            <h2 className="tw-text-2xl tw-font-semibold tw-text-gray-800">
              Activating members
            </h2>
          </div>
          {enableAsyncActivation && (
            <div className="tw-space-y-2">
              <div className="tw-flex tw-justify-between tw-text-sm tw-font-medium tw-text-gray-500">
                <span>Processing...</span>
                <span>
                  {progress} / {totalCount || "Calculating"}
                </span>
              </div>
              <Progress
                value={progressPercentage}
                className="tw-w-full tw-h-2"
              />
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
